import { createFileRoute, Outlet } from '@tanstack/react-router'
import { InspectionScheduling } from 'pages/inspectionScheduling/InspectionScheduling'

export const Route = createFileRoute('/scheduling/{-$siteID}')({
  component: SchedulingRouteComponent,
  staticData: {
    title: 'Scheduling',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})

function SchedulingRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <InspectionScheduling />
}
